import { useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Spinner,
} from "reactstrap";
import { SubmitHandler, useForm } from "react-hook-form";

import VerifyCode from "./verify-code";
import InputGroup from "../common/input-group";
import { forgotPasswordService } from "@/services/authService";
import useAlertBar from "@/hooks/useAlertBar";

type Inputs = {
  email: string;
};

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email Address is required"),
});

export default function ForgotPassword() {
  const [verifyModal, setVerifyModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { openAlertBar } = useAlertBar();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>({
    resolver: yupResolver(validationSchema),
    criteriaMode: "all",
    shouldFocusError: true,
  });

  const onSubmit: SubmitHandler<Inputs> = async (formData) => {
    setLoading(true);
    try {
      const { data } = await forgotPasswordService({
        email: formData.email.toLowerCase(),
      });

      if (data.status) {
        setVerifyModal(true);
        openAlertBar(`${data.message}`, true);
      } else {
        openAlertBar(data.message, false);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      openAlertBar(
        "Unexpected error occurred while generating verification code. Please try again ",
        false
      );
      console.log(error);
    }
  };

  return (
    <Container className="my-5">
      <Col sm={6} xs={12} className="mx-auto">
        <Card>
          <CardBody>
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="my-4 needs-validation"
            >
              <h2 className="text-center mb-4">Forgot Password</h2>
              <InputGroup
                required
                label="Email Address"
                name="email"
                register={register}
                error={errors.email?.message}
              />
              <Button type="submit" disabled={loading} className="w-100">
                SEND ME A SECURE CODE
                {loading && <Spinner size="sm" className="ms-3" />}
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
      <VerifyCode
        isOpen={verifyModal}
        userEmail={watch("email")}
        toggle={() => setVerifyModal((s) => !s)}
      />
    </Container>
  );
}
